
import React from 'react'
import DocumentErrorItem from './DocumentErrorItem'

class DocumentErrorModal extends React.Component {

  handleDismiss() {
    if (this.props.onDismiss) {
      this.props.onDismiss()
    }
  }

  render() {
    const {
      errors
    } = this.props

    return (
      <div className="document-error-model">
        <div className="box">
          <div className="title">
            Errors found while reading file!
          </div>
          <div className="error-list">
            {errors.map((error, idx) => (
              <DocumentErrorItem key={idx} error={error} />
            ))}
          </div>
          <button className="dismiss" onClick={this.handleDismiss.bind(this)}>
            Dismiss
          </button>
        </div>
      </div>
    )
  }
}

export default DocumentErrorModal
